import { render, staticRenderFns } from "./PluginChatGPT.vue?vue&type=template&id=30e5d9d5"
import script from "./PluginChatGPT.vue?vue&type=script&lang=js"
export * from "./PluginChatGPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e5d9d5')) {
      api.createRecord('30e5d9d5', component.options)
    } else {
      api.reload('30e5d9d5', component.options)
    }
    module.hot.accept("./PluginChatGPT.vue?vue&type=template&id=30e5d9d5", function () {
      api.rerender('30e5d9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginChatGPT.vue"
export default component.exports